<template>
    <div>
        <h3>Prompt List &nbsp;&nbsp;&nbsp; Total: {{ sum }} 条</h3>
        <el-form class="el_head_search" ref="form" :model="form" label-width="80px">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="用户名" prop="user">
                        <el-input v-model="form.user"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Prompt Id" prop="prompt_id">
                        <el-input v-model="form.prompt_id"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8" class="btns">
                    <el-button type="primary" size="small" @click="search">搜索</el-button>
                    <el-button type="primary" size="small" @click="resetForm">重置</el-button>
                </el-col>
            </el-row>
        </el-form>

        <el-table v-loading="loading" :data="tableData" border style="width: 100%">
            <el-table-column prop="_id" label="ID" fixed="left" width="200"></el-table-column>
            <el-table-column prop="prompt" label="Prompt-zh">
                <template slot-scope="scope">
                    {{ scope.row.prompts.map(ele => (ele.other ? (ele.other.direction === 'before' ? `${ele.other.text_zh} ${ele.text_zh}` : `${ele.text_zh} ${ele.other.text_zh}`) : ele.text_zh)).join(', ') }}
                </template>
            </el-table-column>
            <el-table-column prop="prompt" label="Prompt-en">
                <template slot-scope="scope">
                    {{ scope.row.prompts.map(ele => (ele.other ? (ele.other.direction === 'before' ? `${ele.other.text_en} ${ele.text_en}` : `${ele.text_en} ${ele.other.text_en}`) : ele.text_en)).join(', ') }}
                </template>
            </el-table-column>
            <el-table-column prop="imageUrl" label="图片链接">
                <template slot-scope="scope">
                    <a v-if="scope.row.imageUrl" class="_link" :href="`https://asset.promptport.ai/files${scope.row.imageUrl}`" target="_blank">{{ $Met.hash(`https://asset.promptport.ai/files${scope.row.imageUrl}`, 14, 20) }}</a>
                    <span v-else>暂未获取</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="创建人" width="160">
                <template slot-scope="scope">
                    {{ scope.row.author_info.name || '--' }}
                </template>
            </el-table-column>
            <el-table-column prop="created_at" width="160" label="创建时间(UTC)">
                <template slot-scope="scope">
                    {{ $moment(new Date(scope.row.created_at).getTime()).utc().format('YYYY-MM-DD HH:mm:ss') }}
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination background :hide-on-single-page="true" layout="prev, pager, next" :page-size="params.size" :current-page="params.page" :total="total" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>

<script>
import serverApi from '../../server/index';
export default {
    data() {
        return {
            sum: 0,
            form: {
                user: '',
                prompt_id: '',
            },

            tableData: [],
            params: {
                page: 1,
                size: 10,
            },
            total: 0,
            loading: true,
        };
    },
    created() {
        this.getVisualPromptList();
    },
    methods: {
        async getVisualPromptList(_params) {
            try {
                const params = {
                    ...this.params,
                    ..._params,
                };
                this.loading = true;
                const { data } = await serverApi.visualPromptList(params);
                if (data.code !== 0) throw new Error(data.error);
                this.tableData = data.data;
                this.total = data.total;
                this.params = params;
                if (!this.sum) this.sum = data.total;
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            } finally {
                this.loading = false;
            }
        },

        handleCurrentChange(val) {
            this.getVisualPromptList({ page: val });
        },
        search() {
            this.params = { page: 1, size: 10 };
            this.getVisualPromptList(this.form);
        },
        resetForm() {
            this.$refs.form.resetFields();
            this.params = { page: 1, size: 10 };
            this.getVisualPromptList(this.form);
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
}
.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}
</style>
